import Vue from 'vue'

const pattern = /[^0-9.]/g;

Vue.directive('digitsAfterDecimal', {
  /**
   * directive for handling decimal input with custom precision; also replacing
   * comma with dot in string
   * 123,321 -> 123.32
   * TODO: potentially there can be an improvement
   * to not allowing write more than 1 dot. is there?
   * @param el - DOM element. dont touch that, please.
   * @param {Object} binding { value: { numberOfDigits } } -
   * should be an object with numberOfDigits that will be a number of precision
   * @param {Object} vNode - virtual node of vue element. use it instead of el
   */
  bind (el, binding, vNode) {
    vNode.elm.oninput = () => {
      const fractionDigits = binding.value
      let replacedValue = vNode.elm.value.replace(',', '.').replace(pattern, '')

      if (replacedValue) {
        const valueAfterSplit = replacedValue.split('.')
        let fractionPart = valueAfterSplit[1]
        if (fractionPart && fractionPart.length > fractionDigits.numberOfDigits) {
          valueAfterSplit[1] = fractionPart.slice(0, fractionDigits.numberOfDigits)
        }
        el.value = valueAfterSplit.join('.')
      }
    }
  }
})

Vue.directive('replaceWithNegative', {
  update(el) {
    const event = new Event('input', { bubbles: true });
    const value = el.value.replace(pattern, '');
      if (value) {
        el.value = Number(value) ? `-${value}` : value;
        el.dispatchEvent(event);
      }
  }
});

Vue.directive('replaceWithNegativeAndDigitsDecimal', {
  bind(el, binding) {
    el.oninput = () => {
      let fractionDigits = binding.value;
      let value = el.value.replace(pattern, '');
      if (value) {
        let arr = value.split('.');
        if (arr[1] && arr[1].length > fractionDigits.numberOfDigits) {
          arr[1] = arr[1].slice(0, fractionDigits.numberOfDigits);
        }
        el.value = `-${arr.join('.')}`;
      }
    }
  }
});

Vue.directive('replaceWithPositive', {
  bind(el) {
    el.oninput = () => {
      const value = el.value.replace(pattern, '');
      if (value) {
        el.value = value;
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/directives/NumericInputDirectives.js